import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../spinner.css';
import { Routes, Route } from 'react-router-dom';
import { getUserDetails } from '../services/UserService';
import 'react-toastify/dist/ReactToastify.css';
import LearnerDashboard from './LearnerDashboard';
import LearnerCourses from './learnings/LearnerCourses';
import LearnerHeader from './layout/LearnerHeader';
import LeanerSidebar from './layout/LearnerSidebar';
import LearnerAssessment from './learnings/LearnerAssessment';
import LearnerCongrats from './learnings/LearnerCongrats';
import LearnerTheory from './learnings/LearnerTheory';
import LearnerCertificate from './learnings/LearnerCertificate';
import LearnerCertificateCompletion from './learnings/LearnerCertificateCompletion';
import LearnerScore from './learnings/LearnerScore';
import LearnerResetPassword from './learnings/LearnerResetPassword';
import LearnerProfile from './learnings/LearnerProfile';
import LearnerGame from './learnings/LearnerGame';
import LearnerVideo from './learnings/LearnerVideo';
import LearnerSearch from './learnings/LearnerSearch'
import LearnerKc from './learnings/LearnerKc';

export default function LearnerRoutes() {
  const navigate = useNavigate();
  useEffect(() => {
    const userDetails = getUserDetails();
    if (userDetails.token === undefined) {
      navigate('/login');
    } else if (userDetails.user.role === "SUPER_ADMIN") {
      navigate('/superadmin/dashboard');
    }
    else if (userDetails.user.role === "ACCOUNT_OWNER") {
      navigate('/admin/dashboard');
    } else if (userDetails.user.role === "LEARNER" && userDetails.user.need_password_change === true) {
      navigate('/learner/passwordreset');
    }



  }, []);
  return (
    <div className='flex'>
      <div className='sidebar-wrap fixed top-0 left-0 h-full hidden lg:block z-50'>
        <LeanerSidebar />
      </div>
      <div className='dash-rigth'>
        <div className='header-wrap'>
          <LearnerHeader />
        </div>
        <Routes>
          <Route path="*" element={<LearnerDashboard />} />
          <Route path="/learner/dashboard" element={<LearnerDashboard />} />
          <Route path="/learner/courses" element={<LearnerCourses />} />
          <Route path="/learner/assessment" element={<LearnerAssessment />} />
          <Route path="/learner/theory" element={<LearnerTheory />} />
          <Route path="/learner/assessmentcomplete" element={<LearnerCongrats />} />
          <Route path="/learner/profile" element={<LearnerProfile />} />
          <Route path="/learner/passwordreset" element={<LearnerResetPassword />} />
          <Route path="/learner/score" element={<LearnerScore />} />
          <Route path="/learner/certificate" element={<LearnerCertificate />} />
          <Route path="/learner/certificatecompletion" element={<LearnerCertificateCompletion />} />
          <Route path="/learner/video" element={<LearnerVideo />} />
          <Route path="/learner/game" element={<LearnerGame />} />
          <Route path="/learner/search-result" element={<LearnerSearch />} />
          <Route path="/learner/kc" element={<LearnerKc />} />

        </Routes>
      </div>
    </div>
  );
};
